import React from "react";
import LoginComponent from "../../shared/ui/login/login.js";
import "../../style.css";
import "../../../../merchant/panel/style.css";
import "../../../../shared/styles/colorDefinitions.css";
import "../../../../shared/styles/buttonStyles.css";
export default function Main(props) {
    return (React.createElement("div", null,
        React.createElement(LoginComponent, null)));
}
